import PropTypes from 'prop-types';
import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from "../../common/noDataComponent";

import './esg.scss';

const SEGMENTS = {
    n1: "n_1",
    n2: "n_2",
    n3: "n_3",
}

const SEGMENT_COLORS = {
    [SEGMENTS.n1]: {
        score: 1,
        colorStart: '#38b394',
        colorEnd: '#a9c812'
    },
    [SEGMENTS.n2]: {
        score: 2,
        colorStart: '#ffd300',
        colorEnd: '#e74310'
    },
    [SEGMENTS.n3]: {
        score: 3,
        colorStart: '#e74310',
        colorEnd: '#c21718'
    },
}
const POINTER_COLOR = "#444749";

class ESGLine extends React.Component {
    render() {
        const { data, score } = this.props;
        return (isNullOrUndefined(data) || isNullOrUndefined(score) ? <NoDataComponent /> : this.renderContent(data, score));
    }

    renderContent(data, score) {
        let segmentData = Object.keys(SEGMENT_COLORS).map(k => ({ value: data[k] || 0, ...SEGMENT_COLORS[k] }));
        segmentData = segmentData.filter(seg => seg.value > 0);

        const total = segmentData.map(x => x.value).reduce((a, b) => a + b, 0);
        const gap = 5;
        const totalGaps = gap * (segmentData.length - 1);
        const segmentWidth = (100 - totalGaps) / total;

        let currentX = 5;

        // pointer position 
        const pointerSegmentArr = segmentData.filter(x => x.score === score);
        const pointerSegmentValue = Array.isArray(pointerSegmentArr) && pointerSegmentArr.length > 0 ? pointerSegmentArr[0].value : 1;
        const segmentStart = segmentData.filter(x => x.score < score).reduce((acc, seg) => acc + seg.value * segmentWidth + gap, currentX);
        const pointerX = segmentStart + (pointerSegmentValue * segmentWidth) / 2;

        return (
            <svg viewBox="0 0 110 15" aria-label="ESG Line" preserveAspectRatio="xMidYMid meet">
                <defs>
                    {segmentData.map((entry, index) => (
                        <linearGradient id={this.getGradientId(index)} key={index} x1="0%" y1="0%" x2="100%" y2="100%" gradientUnits="userSpaceOnUse">
                            <stop offset="0%" style={{ stopColor: entry.colorStart, stopOpacity: 1 }} />
                            <stop offset="50%" style={{ stopColor: entry.colorStart, stopOpacity: 1 }} />
                            <stop offset="100%" style={{ stopColor: entry.colorEnd, stopOpacity: 1 }} />
                        </linearGradient>
                    ))}
                </defs>
                {segmentData.map((segment, index) => {
                    const width = segment.value * segmentWidth;
                    const line = (
                        <line
                            key={index}
                            x1={currentX}
                            y1={5}
                            x2={currentX + width}
                            y2={5}
                            stroke={`url(#${this.getGradientId(index)})`}
                            strokeWidth={2}
                            strokeLinecap="round"
                        />
                    );
                    currentX += width + gap;
                    return line;
                })}
                <polygon
                    points={`${pointerX - 2},8 ${pointerX + 2},8 ${pointerX},5`}
                    fill={POINTER_COLOR}
                />
            </svg>
        );
    }

    getGradientId = (index) => `line-grad-${this.props.id}-${index}`;
}

ESGLine.propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
        n_1: PropTypes.number,
        n_2: PropTypes.number,
        n_3: PropTypes.number,
    }).isRequired,
    score: PropTypes.number.isRequired,
};

ESGLine.defaultProps = {
    data: null,
};

export default withLocalize(ESGLine);